export const featuredFlightKeys = {
  all: ['featured-flight'] as const,
  dates: (from: string, to: string) => ['featured-flight', 'dates', from, to] as const,
  routes: ['featured-flight', 'routes'] as const,
}
